import React from 'react'

export default function CircleCheckIcon({
  size = 15,
  className = 'text-[#ECFFDF]',
  circleFillColor = '#ECFFDF',
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="14.0625" height="14.0625" rx="7.03125" fill={circleFillColor}/>
      <path d="M5.62509 8.63572L9.89517 4.35879C9.9922 4.26152 10.1156 4.21289 10.2654 4.21289C10.4152 4.21289 10.5389 4.26141 10.6363 4.35844C10.7335 4.45547 10.7822 4.57893 10.7822 4.72881C10.7822 4.87881 10.7335 5.0025 10.6363 5.09988L6.06999 9.6593C5.94284 9.78645 5.79454 9.85002 5.62509 9.85002C5.45563 9.85002 5.30733 9.78645 5.18019 9.6593L3.42642 7.91238C3.32915 7.81535 3.28052 7.69195 3.28052 7.54219C3.28052 7.3923 3.32903 7.26867 3.42606 7.17129C3.5231 7.07402 3.64655 7.02539 3.79644 7.02539C3.94644 7.02539 4.07013 7.07402 4.16751 7.17129L5.62509 8.63572Z" fill="#19AE57"/>
    </svg>
  )
}
